import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup
} from '@angular/forms';

export function formGroupForEachControl(
  formGroup: FormGroup,
  fn: (formControl: FormControl) => void
) {
  Object.keys(formGroup.controls).forEach(key => {
    const control = formGroup.get(key);
    handleControlBasedOnType(control, fn);
  });
}

export function formArrayForEachControl(
  formArray: FormArray,
  fn: (formControl: FormControl) => void
) {
  formArray.controls.forEach(control => {
    handleControlBasedOnType(control, fn);
  });
}

function handleControlBasedOnType(
  control: AbstractControl,
  fn: (formControl: FormControl) => void
) {
  switch (control.constructor.name) {
    case 'FormGroup':
      formGroupForEachControl(control as unknown as FormGroup, fn);
      break;
    case 'FormArray':
      formArrayForEachControl(control as unknown as FormArray, fn);
      break;
    case 'FormControl':
      invokeFunctionForControl(control as unknown as FormControl, fn);
      break;
  }
}

function invokeFunctionForControl(
  formControl: FormControl,
  fn: (formControl: FormControl) => void
) {
  fn(formControl);
}

export function getFormErrors(formGroup: FormGroup): { [key: string]: any } {
  const errors: { [key: string]: any } = {};

  if (formGroup.invalid) {
    formGroupForEachControl(formGroup, (control: FormControl) => {
      const path = control.parent ? getControlPath(control) : '';
      if (control.errors) {
        errors[path] = control.errors;
      }
    });
  }

  return errors;
}

export function getControlPath(control: AbstractControl): string {
  let path = '';
  let parent = control.parent;

  while (parent) {
    if (control.constructor.name === 'FormArray') {
      const index = (parent as FormArray).controls.indexOf(control);
      path = `[${index}]${path}`;
    } else if (parent.constructor.name === 'FormGroup') {
      const key = Object.keys(parent.controls).find(
        k => parent.get(k) === control
      );
      path = key + path;
    }
    control = parent;
    parent = parent.parent;

    if (
      parent.constructor.name === 'FormGroup' &&
      !(control.constructor.name === 'FormArray')
    ) {
      path = '.' + path;
    }
  }

  return path.replace(/^\./, ''); // Remove leading dot if present
}
